export default __webpack_public_path__ + "static/media/Arm Binding of the Earth Mother.b7b39d3d.jpg";